import { services } from '@octadesk-tech/services'
import { getParameterHeaders } from './headers'

export const uploadFile = data => {
  const opts = {
    headers: getParameterHeaders(),
    progress: data.progress
  }

  return services
    .createClient('widgetBff')
    .then(client => client.post('upload', data.body, opts))
    .then(res => res.data)
    .then(data.success)
    .catch(data.error)
}
